import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import {
  Card,
  Row,
  Col,
  Button,
  Badge,
  Table,
  Spinner,
  Alert,
  Modal,
  Form,
  InputGroup,
  Tabs,
  Tab,
  ListGroup,
  ProgressBar,
  Toast,
  ToastContainer,
  Dropdown,
  Pagination
} from "react-bootstrap";
import axios from "axios";
import {
  ArrowLeft,
  Pencil,
  Trash,
  CheckCircle,
  XCircle,
  ExclamationCircle,
  Tag,
  List,
  Folder,
  PlusCircle,
  Search,
  People,
  FileText,
  Calendar,
  Clock,
  Check,
  X,
  Eye,
  Save,
  GraphUp,
  Cash,
  Percent,
  Gear,
  ArrowRepeat,
  Activity,
  CreditCard,
  Receipt,
  ClockHistory,
  ExclamationTriangle,
  Person,
  InfoCircle,
  ShieldCheck,
  Bank,
  Briefcase,
  Layers,
  Building,
  Envelope,
  Phone,
  Globe,
  MapPin,
  Wallet,
  ArrowUp,
  ArrowDown
} from "react-bootstrap-icons";

// Configuration de l'API
const API_BASE_URL = process.env.REACT_APP_API_URL;

const CATEGORIES_ENDPOINT = `${API_BASE_URL}/usager-categories`;
const ACTIVITES_ENDPOINT = `${API_BASE_URL}/activites`;
const CONTRIBUABLES_ENDPOINT = `${API_BASE_URL}/taxpayers`;
const TAXES_ENDPOINT = `${API_BASE_URL}/taxes`;
const TERMS_ENDPOINT = `${API_BASE_URL}/terms`;
const PAYMENTS_ENDPOINT = `${API_BASE_URL}/payments`;
const USAGER_CATEGORIES_ENDPOINT = `${API_BASE_URL}/usager-categories`;
 
export default function CategoryUsagersDetails() {
  const navigate = useNavigate();
  const { code_category } = useParams();
  const location = useLocation();
    
  // États principaux
  const [category, setCategory] = useState(location.state?.category || null);
  const [allActivities, setAllActivities] = useState([]);
  const [allTaxes, setAllTaxes] = useState([]);
  const [allTerms, setAllTerms] = useState([]);
  const [allPayments, setAllPayments] = useState([]);
  const [loading, setLoading] = useState(!location.state?.category);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [refreshing, setRefreshing] = useState(false);
  
  // États pour les données supplémentaires
  const [usagerCategories, setUsagerCategories] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [echeances, setEcheances] = useState([]);
  const [subAccounts, setSubAccounts] = useState([]);
  const [assignedTaxes, setAssignedTaxes] = useState([]);
  const [contribuables, setContribuables] = useState([]);
  const [activities, setActivities] = useState([]);
  const [professionnelActivities, setProfessionnelActivities] = useState([]);
  
  // États pour les chargements spécifiques
  const [loadingContribuablesList, setLoadingContribuablesList] = useState(false);
  const [loadingEcheances, setLoadingEcheances] = useState(false);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [loadingProfessionnelActivities, setLoadingProfessionnelActivities] = useState(false);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  
  // États pour les modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editedCategory, setEditedCategory] = useState(null);
  
  // États pour les chargements généraux
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingAllActivities, setLoadingAllActivities] = useState(false);
  const [loadingUsagerCategories, setLoadingUsagerCategories] = useState(false);

  // États pour les notifications
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });

  // États pour les filtres
  const [taxFilterText, setTaxFilterText] = useState('');
  const [taxStatusFilter, setTaxStatusFilter] = useState('all');
  const [contribuableFilterText, setContribuableFilterText] = useState('');
  const [contribuableStatusFilter, setContribuableStatusFilter] = useState('all');
  const [professionnelFilterText, setProfessionnelFilterText] = useState('');
  const [activityFilter, setActivityFilter] = useState('all');
  
  // États pour le tri des contribuables
  const [contribuableSortField, setContribuableSortField] = useState('nom_contribuable');
  const [contribuableSortDirection, setContribuableSortDirection] = useState('asc');

  // États pour la pagination
  const [taxCurrentPage, setTaxCurrentPage] = useState(1);
  const [contribuableCurrentPage, setContribuableCurrentPage] = useState(1);
  const [professionnelCurrentPage, setProfessionnelCurrentPage] = useState(1);
  const [activityPage, setActivityPage] = useState(1);
  const itemsPerPage = 10;
  const activitiesPerPage = 10;
  const professionnelActivitiesPerPage = 10;

  // Fréquences
  const frequencies = {
    annual: "Annuelle",
    monthly: "Mensuelle",
    quarterly: "Trimestrielle",
    semiannual: "Semestrielle",
    daily: "Journalière",
    one_off: "Unique"
  };

  const frequencyIcons = {
    annual: "📅",
    monthly: "📆",
    quarterly: "📊",
    semiannual: "📈",
    daily: "⏰",
    one_off: "🎯"
  };

  // Obtenir le token d'authentification
  const getAuthToken = () => {
    return sessionStorage.getItem("authToken");
  };

  const getHeaders = () => {
    const token = getAuthToken();
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  };

  // Notifications
  const showAlert = (message, type = 'info', duration = 4000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0) {
      setTimeout(() => setAlertMessage(prev => ({ ...prev, show: false })), duration);
    }
  };

  // Formatage
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  const formatCurrency = (amount) => {
    const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' ' + defaultCurrency;
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('fr-FR').format(num || 0);
  };

  const formatRelativeTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    if (diffMins < 1) return "À l'instant";
    if (diffMins < 60) return `Il y a ${diffMins} minute${diffMins > 1 ? 's' : ''}`;
    if (diffHours < 24) return `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
    if (diffDays < 7) return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
    return formatDate(dateString);
  };

  // Obtenir le nom de l'activité à partir de son code
  const getActivityName = (activityId) => {
    if (!activityId) return 'Non spécifiée';
    const activity = allActivities.find(a => 
      parseInt(a.id_export) === parseInt(activityId) || 
      parseInt(a.code_category) === parseInt(activityId)
    );
    return activity?.name || activity?.cat_name || `Activité ${activityId}`;
  };

  // Charger les catégories d'usagers
  const loadUsagerCategories = async () => {
    try {
      setLoadingUsagerCategories(true);
      const response = await axios.get(USAGER_CATEGORIES_ENDPOINT, getHeaders());
      
      let categories = [];
      if (response.data && Array.isArray(response.data)) {
        categories = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        categories = response.data.data;
      }
      
      console.log("📦 Catégories d'usagers chargées:", categories.length);
      setUsagerCategories(categories);
    } catch (err) {
      console.error("❌ Erreur chargement catégories d'usagers:", err);
      setUsagerCategories([]);
    } finally {
      setLoadingUsagerCategories(false);
    }
  };

  // Charger toutes les activités depuis l'API /activites
  const loadAllActivities = async () => {
    try {
      setLoadingAllActivities(true);
      const response = await axios.get(ACTIVITES_ENDPOINT, getHeaders());
      
      console.log("📦 Activités chargées depuis /activites:", response.data);
      
      let activitiesData = [];
      if (response.data && Array.isArray(response.data)) {
        activitiesData = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        activitiesData = response.data.data;
      }
      
      setAllActivities(activitiesData);
      return activitiesData;
    } catch (err) {
      console.error("❌ Erreur chargement activités:", err);
      setAllActivities([]);
      return [];
    } finally {
      setLoadingAllActivities(false);
    }
  };

  // Charger la catégorie
  const loadCategoryData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${CATEGORIES_ENDPOINT}/${code_category}`, getHeaders());
      const categoryData = response.data.data || response.data;
      console.log("📦 Catégorie reçue:", categoryData);
      setCategory(categoryData);
      setEditedCategory(categoryData);
    } catch (err) {
      console.error("❌ Erreur chargement catégorie:", err);
      setError("Erreur lors du chargement de la catégorie");
      showAlert("Erreur lors du chargement", "danger");
    } finally {
      setLoading(false);
    }
  };

  // Charger toutes les taxes
  const loadAllTaxes = async () => {
    try {
      const response = await axios.get(TAXES_ENDPOINT, getHeaders());
      
      let taxesData = [];
      if (response.data && Array.isArray(response.data)) {
        taxesData = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        taxesData = response.data.data;
      }
      
      setAllTaxes(taxesData);
    } catch (err) {
      console.error("❌ Erreur chargement taxes:", err);
      setAllTaxes([]);
    }
  };

  // Charger les taxes de cette catégorie
  const loadTaxes = async () => {
    try {
      const response = await axios.get(TAXES_ENDPOINT, getHeaders());
      let taxesData = [];
      if (response.data && Array.isArray(response.data)) {
        taxesData = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        taxesData = response.data.data;
      }
      
      const filteredTaxes = taxesData.filter(tax => 
        parseInt(tax.code_category) === parseInt(code_category)
      );
      setTaxes(filteredTaxes);
    } catch (error) {
      console.error("Erreur chargement taxes:", error);
      setTaxes([]);
    }
  };

  // Charger les échéances
// Charger les échéances et les mettre dans allTerms
const loadEcheances = async () => {
  try {
    setLoadingEcheances(true);
    const response = await axios.get(TERMS_ENDPOINT, getHeaders());
    let termsData = [];
    if (response.data && Array.isArray(response.data)) {
      termsData = response.data;
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      termsData = response.data.data;
    } else if (response.data && response.data.echeances) {
      termsData = response.data.echeances;
    }
    
    console.log("📦 Échéances chargées:", termsData.length);
    setEcheances(termsData);
    setAllTerms(termsData); // Important: mettre à jour allTerms
  } catch (error) {
    console.error("Erreur chargement échéances:", error);
    setEcheances([]);
    setAllTerms([]);
  } finally {
    setLoadingEcheances(false);
  }
};

  // Charger les paiements
  const loadAllPayments = async () => {
    try {
      setLoadingPayments(true);
      const response = await axios.get(PAYMENTS_ENDPOINT, getHeaders());
      let paymentsData = [];
      if (response.data && Array.isArray(response.data)) {
        paymentsData = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        paymentsData = response.data.data;
      } else if (response.data && response.data.paiements) {
        paymentsData = response.data.paiements;
      }
      setAllPayments(paymentsData);
    } catch (err) {
      console.error("❌ Erreur chargement paiements:", err);
      setAllPayments([]);
    } finally {
      setLoadingPayments(false);
    }
  };

  // Déterminer le statut d'un contribuable
  const determinerStatut = (contribuableItem, echeancesList) => {
    const today = new Date();
    
    const aDesEcheancesEnRetard = echeancesList.some(e => {
      if (!e.date_echeance) return false;
      const dueDate = new Date(e.date_echeance);
      const montantInitial = parseFloat(e.montant_initial) || 0;
      const montantPaye = parseFloat(e.montant_paye) || 0;
      return dueDate < today && montantPaye < montantInitial;
    });

    const aDesImpayes = echeancesList.some(e => {
      const montantInitial = parseFloat(e.montant_initial) || 0;
      const montantPaye = parseFloat(e.montant_paye) || 0;
      return montantPaye < montantInitial;
    });

    if (aDesEcheancesEnRetard) return 'en_retard';
    if (aDesImpayes) return 'impaye';
    if (contribuableItem.is_active === 1 || contribuableItem.statut === "actif") return 'actif';
    return 'inactif';
  };

  // Calculer les paiements d'un contribuable
  const getContribuablePayments = (contribuableId) => {
    return allPayments.filter(p => p.usager_id?.toString() === contribuableId?.toString());
  };

  // Calculer le total payé par un contribuable
  const getTotalPaye = (contribuableId) => {
    const contribuablePayments = getContribuablePayments(contribuableId);
    return contribuablePayments.reduce((sum, p) => sum + (parseFloat(p.montant) || 0), 0);
  };

  // Calculer le nombre de paiements
  const getNombrePaiements = (contribuableId) => {
    return getContribuablePayments(contribuableId).length;
  };

  // Charger les contribuables
 // Charger les contribuables
// Charger les contribuables - VERSION CORRIGÉE
// Charger les contribuables - VERSION CORRIGÉE
const loadContribuables = async () => {
  try {
    setLoadingContribuablesList(true);
    const response = await axios.get(CONTRIBUABLES_ENDPOINT, getHeaders());
    
    let allContribuables = [];
    if (response.data && Array.isArray(response.data)) {
      allContribuables = response.data;
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      allContribuables = response.data.data;
    }

    console.log("📦 Tous les contribuables reçus:", allContribuables.length);
    
    // Récupérer les activités de la catégorie
    const activitiesOfCategory = getActivitiesOfCategory();
    const activityIds = activitiesOfCategory.map(a => parseInt(a.id_export));
    console.log("🎯 IDs des activités de la catégorie:", activityIds);
    
    // IMPORTANT: Récupérer toutes les échéances de tous les contribuables
    // pour pouvoir filtrer par taxe_id ou par activité
    const allTermsData = allTerms; // déjà chargé
    
    console.log("📊 Nombre total d'échéances disponibles:", allTermsData.length);
    
    // Filtrer les contribuables par activité
    const filteredContribuables = allContribuables.filter(c => {
      const contribActivite = parseInt(c.activite_contribuable);
      return activityIds.includes(contribActivite);
    });
    
    console.log("📊 Contribuables filtrés:", filteredContribuables.length);
    
    // Enrichir les contribuables avec leurs échéances et paiements
    const enrichedContribuables = filteredContribuables.map(contrib => {
      // IMPORTANT: Récupérer les échéances de ce contribuable
      // Utiliser contribuable_id pour faire le lien
      const contribuableId = contrib.contribuable_id || contrib.id;
      
      const contribuableTerms = allTermsData.filter(t => {
        // Vérifier par contribuable_id dans l'échéance
        const termContribId = t.contribuable_id || t.usager_id || t.contribuable?.contribuable_id;
        return termContribId === contribuableId;
      });
      
      console.log(`📊 ${contrib.nom_contribuable} (ID: ${contribuableId}) a ${contribuableTerms.length} échéances`);
      
      // Récupérer les paiements du contribuable
      const contribuablePayments = allPayments.filter(p => {
        const paymentUsagerId = p.usager_id || p.contribuable_id;
        return paymentUsagerId?.toString() === contribuableId?.toString();
      });
      
      // Calculer le montant total des échéances
      let montantTotal = 0;
      contribuableTerms.forEach(t => {
        const montant = parseFloat(t.montant_initial) || parseFloat(t.montant_attendu) || parseFloat(t.montant) || 0;
        montantTotal += montant;
        console.log(`  - Échéance: ${montant}, total cumulé: ${montantTotal}`);
      });
      
      // Calculer le montant payé à partir des paiements
      let montantPaye = 0;
      contribuablePayments.forEach(p => {
        const montantP = parseFloat(p.montant) || 0;
        montantPaye += montantP;
        console.log(`  - Paiement: ${montantP}, total payé cumulé: ${montantPaye}`);
      });
      
      const montantRestant = montantTotal - montantPaye;
      
      console.log(`💰 ${contrib.nom_contribuable}: total=${montantTotal}, paye=${montantPaye}, restant=${montantRestant}`);
      
      // Déterminer le statut
      const today = new Date();
      const echeancesEnRetard = contribuableTerms.filter(e => {
        if (!e.date_echeance) return false;
        const dueDate = new Date(e.date_echeance);
        const montantInitial = parseFloat(e.montant_initial) || 0;
        const montantPayeE = parseFloat(e.montant_paye) || 0;
        return dueDate < today && montantPayeE < montantInitial;
      }).length;
      
      let statut = 'actif';
      if (montantRestant > 0 && echeancesEnRetard > 0) {
        statut = 'en_retard';
      } else if (montantRestant > 0) {
        statut = 'impaye';
      } else if (contrib.is_active !== 1) {
        statut = 'inactif';
      }
      
      const nombrePaiements = contribuablePayments.length;
      const tauxPaiement = montantTotal > 0 ? (montantPaye / montantTotal) * 100 : 0;
      
      return {
        ...contrib,
        contribuable_id: contribuableId,
        montant_total: montantTotal,
        montant_paye: montantPaye,
        montant_restant: montantRestant,
        nombre_echeances: contribuableTerms.length,
        echeances_en_retard: echeancesEnRetard,
        statut_calcule: statut,
        taux_paiement: tauxPaiement,
        nombre_paiements: nombrePaiements,
        total_paye_global: montantPaye
      };
    });
    
    setContribuables(enrichedContribuables);
    console.log("✅ Contribuables enrichis:", enrichedContribuables.length);
    
  } catch (err) {
    console.error("❌ Erreur chargement contribuables:", err);
    setContribuables([]);
  } finally {
    setLoadingContribuablesList(false);
  }
};

  // Obtenir les activités de cette catégorie
// Obtenir les activités de cette catégorie
const getActivitiesOfCategory = () => {
  const categoryCode = parseInt(code_category);
  console.log("🔍 Recherche des activités pour la catégorie:", categoryCode);
  console.log("📦 Toutes les activités disponibles:", allActivities.map(a => ({ 
    id: a.id, 
    name: a.name, 
    code_category: a.code_category, 
    type: typeof a.code_category 
  })));
  
  const filteredActivities = allActivities.filter(activity => {
    const activityCode = parseInt(activity.code_category);
    return activityCode === categoryCode;
  });
  
  console.log(`🎯 Activités trouvées pour la catégorie ${categoryCode}:`, filteredActivities.length);
  return filteredActivities;
};

  // Construire les activités de la timeline
  const buildActivities = () => {
    setLoadingTimeline(true);
    
    try {
      const activitiesOfCategory = getActivitiesOfCategory();
      const activityIds = activitiesOfCategory.map(a => a.id_export);
      
      const filteredTerms = echeances.filter(term => {
        const contribuableData = term.contribuable;
        if (!contribuableData) return false;
        const activiteId = parseInt(contribuableData.activite_contribuable);
        return activityIds.includes(activiteId);
      });
      
      const echeancesActivities = filteredTerms.map(term => {
        const montantInitial = parseFloat(term.montant_initial) || 0;
        const montantPaye = parseFloat(term.montant_paye) || 0;
        
        let type = 'echeance';
        let title = 'Échéance créée';
        let color = 'primary';
        let icon = Receipt;
        
        if (term.statut === 'payee' || (montantPaye >= montantInitial && montantInitial > 0)) {
          type = 'paiement';
          title = 'Paiement effectué';
          color = 'success';
          icon = CheckCircle;
        } else if (term.statut === 'expiree' || (term.date_echeance && new Date(term.date_echeance) < new Date() && montantPaye === 0)) {
          type = 'alerte';
          title = 'Échéance expirée';
          color = 'danger';
          icon = XCircle;
        } else if (montantPaye > 0 && montantPaye < montantInitial) {
          type = 'alerte';
          title = 'Paiement partiel';
          color = 'warning';
          icon = ExclamationTriangle;
        }
        
        return {
          id: `term-${term.id}`,
          date: term.date_echeance || term.created_at,
          type: type,
          title: title,
          description: `${term.taxe?.titre || 'Taxe'} - Période: ${term.periode || ''}`,
          montant: montantInitial,
          montantPaye: montantPaye,
          reste: montantInitial - montantPaye,
          contribuable: term.contribuable,
          taxe: term.taxe,
          reference: term.reference || term.paiement_id,
          color: color,
          icon: icon
        };
      });
      
      setActivities(echeancesActivities.sort((a, b) => new Date(b.date) - new Date(a.date)));
    } catch (err) {
      console.error("❌ Erreur construction activités:", err);
      setActivities([]);
    } finally {
      setLoadingTimeline(false);
    }
  };

  // Construire les activités professionnelles
  const buildProfessionnelActivities = useCallback(() => {
    const activitiesOfCategory = getActivitiesOfCategory();
    
    if (activitiesOfCategory.length === 0) {
      setProfessionnelActivities([]);
      return;
    }

    setLoadingProfessionnelActivities(true);
    
    const activitiesMap = new Map();

    activitiesOfCategory.forEach(activity => {
      const contribuablesWithActivity = contribuables.filter(c => 
        parseInt(c.activite_contribuable) === parseInt(activity.id_export)
      );
      
      let montantTotal = 0;
      let montantPaye = 0;
      let nombreEcheances = 0;
      let nombreEcheancesEnRetard = 0;
      
      const allCategoryEcheances = echeances.filter(e => {
        const taxeCorrespondante = taxes.find(t => t.taxe_id === e.taxe_id);
        if (taxeCorrespondante) return true;
        
        if (e.contribuable) {
          const contribActivite = contribuables.find(c => 
            c.contribuable_id === e.contribuable?.contribuable_id
          );
          if (contribActivite && parseInt(contribActivite.activite_contribuable) === parseInt(activity.id_export)) {
            return true;
          }
        }
        return false;
      });
      
      allCategoryEcheances.forEach(echeance => {
        const initial = parseFloat(echeance.montant_initial || echeance.montant_attendu || 0);
        const paye = parseFloat(echeance.montant_paye || 0);
        montantTotal += initial;
        montantPaye += paye;
        nombreEcheances++;
        
        const dueDate = new Date(echeance.date_echeance);
        const today = new Date();
        if (dueDate < today && paye < initial) {
          nombreEcheancesEnRetard++;
        }
      });
      
      const finalMontantTotal = montantTotal;
      const finalMontantPaye = montantPaye;
      const tauxPaiement = finalMontantTotal > 0 ? (finalMontantPaye / finalMontantTotal) * 100 : 0;
      
      activitiesMap.set(activity.id_export, {
        id: activity.id,
        code: activity.id_export,
        nom: activity.name,
        description: activity.description,
        cat_name: activity.cat_name,
        tax_category_name: activity.tax_category_name,
        category: activity.category,
        tax_category: activity.tax_category,
        contribuables: contribuablesWithActivity,
        nombreContribuables: contribuablesWithActivity.length,
        montantTotal: finalMontantTotal,
        montantPaye: finalMontantPaye,
        montantRestant: finalMontantTotal - finalMontantPaye,
        nombreEcheances: nombreEcheances,
        nombreEcheancesEnRetard: nombreEcheancesEnRetard,
        tauxPaiement: tauxPaiement
      });
    });

    const activitiesArray = Array.from(activitiesMap.values())
      .sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));

    setProfessionnelActivities(activitiesArray);
    setLoadingProfessionnelActivities(false);
  }, [contribuables, echeances, taxes, allActivities, code_category]);

  // Fonction de tri pour les contribuables
  const handleContribuableSort = (field) => {
    if (contribuableSortField === field) {
      setContribuableSortDirection(contribuableSortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setContribuableSortField(field);
      setContribuableSortDirection('asc');
    }
  };

  // Composant pour l'en-tête triable
  const SortableHeader = ({ field, children }) => (
    <th 
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => handleContribuableSort(field)}
      className="position-relative"
    >
      <div className="d-flex align-items-center">
        {children}
        {contribuableSortField === field && (
          <span className="ms-1">
            {contribuableSortDirection === 'asc' ? <ArrowUp size={12} /> : <ArrowDown size={12} />}
          </span>
        )}
      </div>
    </th>
  );

  // Effets pour charger les données
useEffect(() => {
  const loadData = async () => {
    await loadCategoryData();
    await loadAllActivities();
    await loadAllTaxes();
    await loadAllPayments();
    await loadUsagerCategories();
  };
  loadData();
}, [code_category]);

 useEffect(() => {
  if (allActivities.length > 0 && code_category) {
    loadTaxes();
    loadEcheances(); // Charge les échéances dans allTerms
  }
}, [allActivities, code_category]);

// Attendre que allTerms soit rempli avant de charger les contribuables
useEffect(() => {
  if (allTerms.length > 0 && allPayments.length > 0 && allActivities.length > 0) {
    console.log("✅ Toutes les données sont prêtes, chargement des contribuables...");
    console.log("📊 allTerms a", allTerms.length, "échéances");
    console.log("📊 allPayments a", allPayments.length, "paiements");
    loadContribuables();
    buildActivities();
  }
}, [allTerms, allPayments, allActivities]);
  useEffect(() => {
    if (echeances.length > 0 && allPayments.length > 0) {
      loadContribuables();
      buildActivities();
    }
  }, [echeances, allPayments]);

  useEffect(() => {
    if (contribuables.length > 0 && echeances.length > 0) {
      buildProfessionnelActivities();
    }
  }, [contribuables, echeances, buildProfessionnelActivities]);

  // Filtrer et trier les contribuables
  const filteredAndSortedContribuables = contribuables
    .filter(c => {
      const matchesSearch = c.nom_contribuable?.toLowerCase().includes(contribuableFilterText.toLowerCase()) ||
        c.email?.toLowerCase().includes(contribuableFilterText.toLowerCase()) ||
        c.telephone?.includes(contribuableFilterText) ||
        c.contribuable_id?.toString().includes(contribuableFilterText);
      const matchesStatus = contribuableStatusFilter === 'all' ||
        (contribuableStatusFilter === 'active' && c.is_active === 1) ||
        (contribuableStatusFilter === 'inactive' && c.is_active !== 1);
      return matchesSearch && matchesStatus;
    })
    .sort((a, b) => {
      let aValue = a[contribuableSortField] || '';
      let bValue = b[contribuableSortField] || '';
      
      if (contribuableSortField === 'montant_total') {
        aValue = a.montant_total || 0;
        bValue = b.montant_total || 0;
      } else if (contribuableSortField === 'montant_paye') {
        aValue = a.montant_paye || 0;
        bValue = b.montant_paye || 0;
      } else if (contribuableSortField === 'taux_paiement') {
        aValue = a.taux_paiement || 0;
        bValue = b.taux_paiement || 0;
      } else if (contribuableSortField === 'nombre_paiements') {
        aValue = a.nombre_paiements || 0;
        bValue = b.nombre_paiements || 0;
      } else if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      
      if (contribuableSortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

  // Pagination des contribuables
  const contribuableTotalPages = Math.ceil(filteredAndSortedContribuables.length / itemsPerPage);
  const contribuableStartIndex = (contribuableCurrentPage - 1) * itemsPerPage;
  const paginatedContribuables = filteredAndSortedContribuables.slice(
    contribuableStartIndex, 
    contribuableStartIndex + itemsPerPage
  );

  // Calcul des statistiques
  const stats = {
    totalTaxes: taxes.length,
    activesTaxes: taxes.filter(t => t.actif === 1).length,
    inactivesTaxes: taxes.filter(t => t.actif !== 1).length,
    montantTotal: taxes.reduce((sum, t) => sum + (parseFloat(t.montant) || 0), 0),
    totalContribuables: contribuables.length,
    totalActivities: activities.length,
    totalProfessionnelActivities: professionnelActivities.length,
    montantTotalContribuables: contribuables.reduce((sum, c) => sum + (c.montant_total || 0), 0),
    montantPayeContribuables: contribuables.reduce((sum, c) => sum + (c.montant_paye || 0), 0),
    tauxRecouvrementGlobal: contribuables.reduce((sum, c) => sum + (c.montant_total || 0), 0) > 0
      ? (contribuables.reduce((sum, c) => sum + (c.montant_paye || 0), 0) / contribuables.reduce((sum, c) => sum + (c.montant_total || 0), 0)) * 100
      : 0
  };

  // Filtrer les taxes
  const filteredTaxes = taxes.filter(t => {
    const matchesSearch = t.titre?.toLowerCase().includes(taxFilterText.toLowerCase()) ||
      t.description?.toLowerCase().includes(taxFilterText.toLowerCase());
    const matchesStatus = taxStatusFilter === 'all' ||
      (taxStatusFilter === 'active' && t.actif === 1) ||
      (taxStatusFilter === 'inactive' && t.actif !== 1);
    return matchesSearch && matchesStatus;
  });

  // Filtrer les activités de la timeline
  const filteredActivities = activities.filter(activity => 
    activityFilter === 'all' || activity.type === activityFilter
  );

  // Filtrer les activités professionnelles
  const filteredProfessionnelActivities = professionnelActivities.filter(activity => 
    activity.nom.toLowerCase().includes(professionnelFilterText.toLowerCase()) ||
    activity.code?.toString().toLowerCase().includes(professionnelFilterText.toLowerCase()) ||
    (activity.cat_name && activity.cat_name.toLowerCase().includes(professionnelFilterText.toLowerCase()))
  );

  // Pagination
  const taxTotalPages = Math.ceil(filteredTaxes.length / itemsPerPage);
  const taxStartIndex = (taxCurrentPage - 1) * itemsPerPage;
  const paginatedTaxes = filteredTaxes.slice(taxStartIndex, taxStartIndex + itemsPerPage);

  const activityTotalPages = Math.ceil(filteredActivities.length / activitiesPerPage);
  const activityStartIndex = (activityPage - 1) * activitiesPerPage;
  const paginatedActivities = filteredActivities.slice(activityStartIndex, activityStartIndex + activitiesPerPage);

  const professionnelTotalPages = Math.ceil(filteredProfessionnelActivities.length / professionnelActivitiesPerPage);
  const professionnelStartIndex = (professionnelCurrentPage - 1) * professionnelActivitiesPerPage;
  const paginatedProfessionnelActivities = filteredProfessionnelActivities.slice(
    professionnelStartIndex, 
    professionnelStartIndex + professionnelActivitiesPerPage
  );

  // Gestion des actions
  const handleRefresh = async () => {
    setRefreshing(true);
    await loadCategoryData();
    await loadAllActivities();
    await loadAllTaxes();
    await loadAllPayments();
    await loadUsagerCategories();
    await loadTaxes();
    await loadEcheances();
    setRefreshing(false);
    showAlert("Données actualisées avec succès", "success");
  };

  const handleSaveEdit = async () => {
    if (!editedCategory?.name?.trim()) {
      showAlert("Le nom de la catégorie est requis", "warning");
      return;
    }

    setLoadingUpdate(true);
    try {
      await axios.put(
        `${CATEGORIES_ENDPOINT}/${code_category}`,
        {
          name: editedCategory.name,
          description: editedCategory.description
        },
        getHeaders()
      );

      setCategory(editedCategory);
      setShowEditModal(false);
      showAlert("Catégorie modifiée avec succès", "success");
      await loadCategoryData();
    } catch (err) {
      console.error("❌ Erreur modification:", err);
      showAlert("Erreur lors de la modification", "danger");
    } finally {
      setLoadingUpdate(false);
    }
  };

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      await axios.delete(`${CATEGORIES_ENDPOINT}/${code_category}`, getHeaders());
      showAlert("Catégorie supprimée avec succès", "success");
      setTimeout(() => navigate('/agent/contribuables/Categories'), 2000);
    } catch (err) {
      console.error("❌ Erreur suppression:", err);
      showAlert("Erreur lors de la suppression", "danger");
    } finally {
      setLoadingDelete(false);
    }
  };

  const getRecoveryVariant = (taux) => {
    if (taux >= 75) return "success";
    if (taux >= 50) return "info";
    if (taux >= 25) return "warning";
    return "danger";
  };

  const getStatusBadge = (contribuableItem) => {
    const statut = contribuableItem.statut_calcule || "inconnu";
    
    const config = {
      actif: { label: "Actif", color: "success", icon: <CheckCircle className="me-1" size={12} /> },
      impaye: { label: "Impayé", color: "warning", icon: <Cash className="me-1" size={12} /> },
      en_retard: { label: "En retard", color: "danger", icon: <ExclamationCircle className="me-1" size={12} /> },
      inactif: { label: "Inactif", color: "secondary", icon: <XCircle className="me-1" size={12} /> },
      inconnu: { label: "Inconnu", color: "light", icon: null }
    };
    
    const cfg = config[statut] || config.inconnu;
    
    return (
      <Badge bg={cfg.color} pill className="px-3 py-2 d-flex align-items-center gap-1">
        {cfg.icon}
        {cfg.label}
      </Badge>
    );
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="main main-app p-4 d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
          <div className="text-center">
            <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
            <h5 className="mt-3">Chargement de la catégorie</h5>
            <p className="text-muted">Veuillez patienter...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !category) {
    return (
      <>
        <Header />
        <div className="main main-app p-4">
          <Alert variant="danger" className="text-center py-5">
            <ExclamationCircle size={48} className="mb-3" />
            <h4>Erreur</h4>
            <p>{error || "Catégorie non trouvée"}</p>
            <Button variant="primary" onClick={() => navigate('/agent/contribuables/Categories')} className="mt-3">
              <ArrowLeft className="me-2" /> Retour à la liste
            </Button>
          </Alert>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        <Toast
          show={alertMessage.show}
          onClose={() => setAlertMessage({ ...alertMessage, show: false })}
          bg={alertMessage.type}
          delay={4000}
          autohide
        >
          <Toast.Header closeButton={false}>
            {alertMessage.type === 'success' && <CheckCircle className="me-2" />}
            {alertMessage.type === 'danger' && <XCircle className="me-2" />}
            {alertMessage.type === 'warning' && <ExclamationCircle className="me-2" />}
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{alertMessage.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="main main-app p-4" style={{ background: '#f0f2f5' }}>
        <div className="container-fluid">
          {/* En-tête */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <Button 
                variant="link" 
                className="p-0 text-decoration-none mb-2 d-flex align-items-center text-muted"
                onClick={() => navigate('/agent/contribuables/Categories')}
              >
                <ArrowLeft className="me-1" size={16} />
                Retour aux catégories
              </Button>
              <h1 className="display-6 fw-bold mb-1 d-flex align-items-center gap-3">
                {category.name}
                <Badge bg="primary" className="fs-6 px-3 py-2">
                  <Tag className="me-1" size={14} />
                  Code: {category.code_category}
                </Badge>
              </h1>
              <p className="text-muted mb-0">
                <Calendar className="me-1" size={14} />
                Créée le {formatDate(category.created_at)}
              </p>
            </div>
            <div className="d-flex gap-2">
              <Button variant="light" onClick={handleRefresh} disabled={refreshing}>
                <ArrowRepeat className={`me-2 ${refreshing ? 'spin' : ''}`} size={16} />
                Actualiser
              </Button>
              {/* <Button variant="outline-primary" onClick={() => setShowEditModal(true)}>
                <Pencil className="me-2" size={16} />
                Modifier
              </Button> */}
              {/* <Button variant="outline-danger" onClick={() => setShowDeleteModal(true)}>
                <Trash className="me-2" size={16} />
                Supprimer
              </Button> */}
            </div>
          </div>

          {/* Description */}
          {category.description && (
            <Card className="border-0 shadow-sm mb-4">
              <Card.Body className="py-3">
                <div className="d-flex align-items-center">
                  <FileText className="text-primary me-2" size={20} />
                  <span className="text-muted">{category.description}</span>
                </div>
              </Card.Body>
            </Card>
          )}

          {/* Cartes de statistiques */}
          <Row className="g-4 mb-4">
            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Activités</p>
                      <h2 className="fw-bold mb-0">{formatNumber(stats.totalProfessionnelActivities)}</h2>
                    </div>
                    <div className="bg-primary bg-opacity-10 p-3 rounded-circle">
                      <Folder className="text-primary" size={24} />
                    </div>
                  </div>
                  <small className="text-muted">
                    Activités professionnelles de cette catégorie
                  </small>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Contribuables</p>
                      <h2 className="fw-bold mb-0">{formatNumber(stats.totalContribuables)}</h2>
                    </div>
                    <div className="bg-info bg-opacity-10 p-3 rounded-circle">
                      <People className="text-info" size={24} />
                    </div>
                  </div>
                  <small className="text-muted">
                    <Wallet className="me-1" size={12} />
                    Total dû: {formatCurrency(stats.montantTotalContribuables)}
                  </small>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Échéances</p>
                      <h2 className="fw-bold mb-0">{formatNumber(stats.totalActivities)}</h2>
                    </div>
                    <div className="bg-warning bg-opacity-10 p-3 rounded-circle">
                      <ClockHistory className="text-warning" size={24} />
                    </div>
                  </div>
                  <small className="text-muted">
                    Échéances associées aux contribuables
                  </small>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={3} md={6}>
              <Card className="border-0 shadow-sm h-100 stats-card">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <p className="text-muted text-uppercase small fw-semibold mb-1">Recouvrement</p>
                      <h2 className="fw-bold mb-0">{stats.tauxRecouvrementGlobal.toFixed(1)}%</h2>
                    </div>
                    <div className="bg-success bg-opacity-10 p-3 rounded-circle">
                      <GraphUp className="text-success" size={24} />
                    </div>
                  </div>
                  <ProgressBar 
                    now={stats.tauxRecouvrementGlobal} 
                    variant={getRecoveryVariant(stats.tauxRecouvrementGlobal)} 
                    className="mt-2"
                    style={{ height: '6px', borderRadius: '3px' }}
                  />
                  <small className="text-muted mt-2 d-block">
                    {formatCurrency(stats.montantPayeContribuables)} encaissés
                  </small>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Tabs */}
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-bottom p-0">
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="px-4 pt-3"
              >
                <Tab 
                  eventKey="overview" 
                  title={
                    <span>
                      <InfoCircle className="me-2" size={16} />
                      Aperçu
                    </span>
                  }
                >
                  <div className="p-4">
                    <Row>
                      <Col md={6}>
                        <h6 className="fw-semibold mb-3">Informations générales</h6>
                        <ListGroup variant="flush" className="border-0">
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom bg-transparent">
                            <span className="text-muted">Nom de la catégorie</span>
                            <span className="fw-semibold">{category.name}</span>
                          </ListGroup.Item>
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom bg-transparent">
                            <span className="text-muted">Code</span>
                            <Badge bg="light" text="dark" className="px-3 py-2">
                              {category.code_category}
                            </Badge>
                          </ListGroup.Item>
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom bg-transparent">
                            <span className="text-muted">ID</span>
                            <Badge bg="light" text="dark" className="px-3 py-2">
                              {category.id}
                            </Badge>
                          </ListGroup.Item>
                          <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3 bg-transparent">
                            <span className="text-muted">Créée le</span>
                            <span className="fw-semibold">{formatDate(category.created_at)}</span>
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col md={6}>
                        <h6 className="fw-semibold mb-3">Statistiques clés</h6>
                        <Row className="g-3">
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <Folder className="text-primary mb-2" size={24} />
                              <h4 className="mb-0">{formatNumber(stats.totalProfessionnelActivities)}</h4>
                              <small className="text-muted">Activités</small>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <People className="text-success mb-2" size={24} />
                              <h4 className="mb-0">{formatNumber(stats.totalContribuables)}</h4>
                              <small className="text-muted">Contribuables</small>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <ClockHistory className="text-warning mb-2" size={24} />
                              <h4 className="mb-0">{formatNumber(stats.totalActivities)}</h4>
                              <small className="text-muted">Échéances</small>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="bg-light p-3 rounded-3 text-center">
                              <Percent className="text-info mb-2" size={24} />
                              <h4 className="mb-0">{stats.tauxRecouvrementGlobal.toFixed(1)}%</h4>
                              <small className="text-muted">Recouvrement</small>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {/* Liste des activités de la catégorie */}
                    {professionnelActivities.length > 0 && (
                      <div className="mt-4">
                        <h6 className="fw-semibold mb-3 d-flex align-items-center">
                          <Briefcase className="me-2 text-primary" size={16} />
                          Activités de cette catégorie
                        </h6>
                        {loadingProfessionnelActivities ? (
                          <div className="text-center py-3">
                            <Spinner animation="border" size="sm" variant="primary" />
                            <small className="ms-2 text-muted">Chargement des activités...</small>
                          </div>
                        ) : (
                          <div className="table-responsive">
                            <Table hover className="align-middle">
                              <thead className="table-light">
                                <tr>
                                  <th>Code</th>
                                  <th>Intitulé</th>
                                  <th>Catégorie fiscale</th>
                                  <th className="text-center">Contribuables</th>
                                </tr>
                              </thead>
                              <tbody>
                                {professionnelActivities.slice(0, 5).map((activity, idx) => (
                                  <tr key={idx}>
                                    <td><Badge bg="primary" pill>{activity.code}</Badge></td>
                                    <td><div className="fw-semibold">{activity.nom}</div></td>
                                    <td><Badge bg="info">{activity.tax_category_name || 'Non définie'}</Badge></td>
                                    <td className="text-center"><Badge bg="secondary" pill>{activity.nombreContribuables}</Badge></td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        )}
                        {professionnelActivities.length > 5 && (
                          <div className="text-center mt-2">
                            <Button variant="link" size="sm" onClick={() => setActiveTab("activities")}>
                              Voir les {professionnelActivities.length} activités
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Tab>

              <Tab 
  eventKey="contribuables" 
  title={
    <span>
      <People className="me-2" size={16} />
      Contribuables ({filteredAndSortedContribuables.length})
      {loadingContribuablesList && <Spinner animation="border" size="sm" className="ms-2" />}
    </span>
  }
>
  <div className="p-4">
    <div className="d-flex gap-3 mb-4">
      <InputGroup style={{ maxWidth: '350px' }}>
        <InputGroup.Text><Search size={16} /></InputGroup.Text>
        <Form.Control
          placeholder="Rechercher un contribuable..."
          value={contribuableFilterText}
          onChange={(e) => setContribuableFilterText(e.target.value)}
        />
      </InputGroup>
      <Form.Select
        style={{ width: '200px' }}
        value={contribuableStatusFilter}
        onChange={(e) => setContribuableStatusFilter(e.target.value)}
      >
        <option value="all">Tous les statuts</option>
        <option value="active">Actifs</option>
        <option value="inactive">Inactifs</option>
      </Form.Select>
      {(contribuableFilterText || contribuableStatusFilter !== 'all') && (
        <Button 
          variant="outline-secondary" 
          size="sm"
          onClick={() => {
            setContribuableFilterText('');
            setContribuableStatusFilter('all');
          }}
        >
          <X size={14} className="me-1" /> Réinitialiser
        </Button>
      )}
    </div>

    {loadingContribuablesList ? (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Chargement des contribuables...</p>
      </div>
    ) : filteredAndSortedContribuables.length === 0 ? (
      <div className="text-center py-5">
        <People size={48} className="text-muted mb-3 opacity-25" />
        <h5>Aucun contribuable trouvé</h5>
        <p className="text-muted">
          {contribuableFilterText ? "Aucun contribuable ne correspond à votre recherche" : "Aucun contribuable n'est associé à cette catégorie"}
        </p>
      </div>
    ) : (
      <>
        <div className="table-responsive">
          <Table hover className="align-middle">
            <thead className="table-light">
              <tr>
                <th>ID</th>
                <SortableHeader field="nom_contribuable">Nom</SortableHeader>
                <SortableHeader field="activite_contribuable">Activité</SortableHeader>
                <SortableHeader field="telephone">Contact</SortableHeader>
                <SortableHeader field="nombre_echeances" className="text-center">Échéances</SortableHeader>
                <SortableHeader field="montant_total" className="text-end">Montant total</SortableHeader>
                <SortableHeader field="montant_paye" className="text-end">Montant payé</SortableHeader>
                <SortableHeader field="montant_restant" className="text-end">Reste à payer</SortableHeader>
                <SortableHeader field="nombre_paiements" className="text-center">Paiements</SortableHeader>
                {/* <SortableHeader field="taux_paiement" className="text-center">Taux</SortableHeader>
               */}
              
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedContribuables.map(c => {
                const activity = professionnelActivities.find(a => a.code === parseInt(c.activite_contribuable));
                const activityName = activity?.nom || getActivityName(c.activite_contribuable) || `Activité ${c.activite_contribuable}`;
                
                // Calculer le nombre réel de paiements à partir des données
                const realNbPaiements = allPayments.filter(p => 
                  p.usager_id?.toString() === (c.contribuable_id || c.id)?.toString()
                ).length;
                
                const realMontantPaye = allPayments
                  .filter(p => p.usager_id?.toString() === (c.contribuable_id || c.id)?.toString())
                  .reduce((sum, p) => sum + (parseFloat(p.montant) || 0), 0);
                
                return (
                  <tr 
                    key={c.contribuable_id || c.id} 
                    style={{ cursor: 'pointer' }}
                  >
                    <td>
                      <Badge bg="light" text="dark" className="fw-semibold px-3 py-2">
                        {c.contribuable_id || c.id}
                      </Badge>
                    </td>
                    <td>
                      <div className="fw-semibold">{c.nom_contribuable}</div>
                    </td>
                    <td>
                      <Badge bg="info" pill className="px-3 py-2">
                        {activityName}
                      </Badge>
                    </td>
                    <td>
                      <div>
                        {c.telephone && (
                          <div className="d-flex align-items-center gap-1">
                            <Phone size={12} className="text-muted" />
                            <small>{c.telephone}</small>
                          </div>
                        )}
                        {/* {c.email && (
                          <div className="d-flex align-items-center gap-1 mt-1">
                            <Envelope size={12} className="text-muted" />
                            <small>{c.email}</small>
                          </div>
                        )} */}
                      </div>
                    </td>
                    <td className="text-center">
                      <Badge bg="secondary" pill className="px-3 py-2">
                        {c.nombre_echeances || 0}
                      </Badge>
                      {c.echeances_en_retard > 0 && (
                        <small className="text-danger d-block">
                          ⚠️ {c.echeances_en_retard} en retard
                        </small>
                      )}
                    </td>
                   <td className="text-end">
  <span className="fw-bold text-primary">
    {formatCurrency(c.montant_total)}
  </span>
</td>
<td className="text-end">
  <span className="fw-bold text-success">
    {formatCurrency(c.montant_paye)}
  </span>
</td>
<td className="text-end">
  <span className="fw-bold text-danger">
    {formatCurrency(c.montant_restant)}
  </span>
</td>
<td className="text-center">
  <Badge bg="info" pill className="px-3 py-2">
    {c.nombre_paiements || 0}
  </Badge>
</td>
                  
                    {/* <td style={{ minWidth: '50px' }}>
                      <div className="d-flex align-items-center gap-2">
                        <ProgressBar 
                          now={c.montant_total > 0 ? (realMontantPaye / c.montant_total) * 100 : 0} 
                          variant={getRecoveryVariant(c.montant_total > 0 ? (realMontantPaye / c.montant_total) * 100 : 0)} 
                          style={{ height: '6px', width: '50px' }}
                        />
                        <small className="fw-semibold">
                          {c.montant_total > 0 ? ((realMontantPaye / c.montant_total) * 100).toFixed(0) : 0}%
                        </small>
                      </div>
                    </td> */}
                    <td className="text-center">
                      {getStatusBadge(c)}
                    </td>
                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="rounded-circle d-flex align-items-center justify-content-center mx-auto"
                        style={{ width: '32px', height: '32px' }}
                        onClick={() => navigate(`/agent/ContribuableDetails/${c.contribuable_id || c.id}`)}
                        title="Voir les détails"
                      >
                        <Eye size={14} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        {contribuableTotalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="text-muted small">
              Affichage de {contribuableStartIndex + 1} à {Math.min(contribuableStartIndex + itemsPerPage, filteredAndSortedContribuables.length)} sur {filteredAndSortedContribuables.length} contribuables
            </div>
            <Pagination size="sm" className="mb-0">
              <Pagination.Prev 
                disabled={contribuableCurrentPage === 1}
                onClick={() => setContribuableCurrentPage(p => p - 1)}
              />
              {[...Array(Math.min(5, contribuableTotalPages))].map((_, i) => {
                let pageNum = i + 1;
                if (contribuableCurrentPage > 3 && contribuableTotalPages > 5) {
                  pageNum = contribuableCurrentPage - 2 + i;
                  if (pageNum > contribuableTotalPages) return null;
                }
                return (
                  <Pagination.Item 
                    key={pageNum} 
                    active={pageNum === contribuableCurrentPage} 
                    onClick={() => setContribuableCurrentPage(pageNum)}
                  >
                    {pageNum}
                  </Pagination.Item>
                );
              })}
              <Pagination.Next 
                disabled={contribuableCurrentPage === contribuableTotalPages}
                onClick={() => setContribuableCurrentPage(p => p + 1)}
              />
            </Pagination>
          </div>
        )}
      </>
    )}
  </div>
</Tab>
             <Tab 
  eventKey="activities" 
  title={
    <span>
      <Folder className="me-2" size={16} />
      Activités ({professionnelActivities.length})
      {loadingProfessionnelActivities && <Spinner animation="border" size="sm" className="ms-2" />}
    </span>
  }
>
  <div className="p-4">
    <div className="mb-4" style={{ maxWidth: '400px' }}>
      <InputGroup>
        <InputGroup.Text><Search size={16} /></InputGroup.Text>
        <Form.Control
          placeholder="Rechercher une activité..."
          value={professionnelFilterText}
          onChange={(e) => setProfessionnelFilterText(e.target.value)}
        />
      </InputGroup>
    </div>

    {loadingProfessionnelActivities ? (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Chargement des activités...</p>
      </div>
    ) : paginatedProfessionnelActivities.length === 0 ? (
      <div className="text-center py-5">
        <Folder size={48} className="text-muted mb-3 opacity-25" />
        <h5>Aucune activité trouvée</h5>
        <p className="text-muted">
          {professionnelFilterText ? "Aucune activité ne correspond à votre recherche" : "Aucune activité professionnelle n'est associée aux contribuables"}
        </p>
      </div>
    ) : (
      <>
        <div className="table-responsive">
          <Table hover className="align-middle">
            <thead className="table-light">
              <tr>
                <th>Code</th>
                <th>Intitulé de l'activité</th>
                <th className="text-center">Contribuables</th>
                <th className="text-center">Échéances</th>
                <th className="text-end">Montant total</th>
                <th className="text-end">Montant payé</th>
                <th className="text-end">Reste à payer</th>
                <th className="text-center">Taux de recouvrement</th>
              </tr>
            </thead>
            <tbody>
              {paginatedProfessionnelActivities.map((activity, index) => (
                <tr key={activity.code || index}>
                  <td>
                    <Badge bg="primary" pill className="px-3 py-2">
                      {activity.code}
                    </Badge>
                  </td>
                  <td>
                    <div className="fw-semibold">{activity.nom}</div>
                    {activity.description && (
                      <small className="text-muted d-block">{activity.description.substring(0, 50)}...</small>
                    )}
                    <div className="mt-1">
                      <Badge bg="secondary" pill className="me-1">
                        {activity.cat_name || '-'}
                      </Badge>
                      <Badge bg="info" pill>
                        {activity.tax_category_name || 'Non définie'}
                      </Badge>
                    </div>
                  </td>
                  <td className="text-center">
                    <Badge bg="info" pill className="px-3 py-2">
                      <People className="me-1" size={12} />
                      {formatNumber(activity.nombreContribuables)}
                    </Badge>
                  </td>
                  <td className="text-center">
                    <Badge bg="secondary" pill className="px-3 py-2">
                      <Receipt className="me-1" size={12} />
                      {formatNumber(activity.nombreEcheances)}
                    </Badge>
                  </td>
                  <td className="text-end">
                    <span className="fw-bold text-primary">
                      {formatCurrency(activity.montantTotal)}
                    </span>
                  </td>
                  <td className="text-end">
                    <span className="fw-bold text-success">
                      {formatCurrency(activity.montantPaye)}
                    </span>
                    {activity.montantPaye === 0 && activity.nombreContribuables > 0 && (
                      <div className="small text-warning">Aucun paiement</div>
                    )}
                  </td>
                  <td className="text-end">
                    <span className="fw-bold text-danger">
                      {formatCurrency(activity.montantRestant)}
                    </span>
                  </td>
                  <td style={{ minWidth: '120px' }}>
                    <div className="d-flex align-items-center gap-2">
                      <ProgressBar 
                        now={activity.tauxPaiement} 
                        variant={getRecoveryVariant(activity.tauxPaiement)} 
                        style={{ height: '8px', width: '100px', borderRadius: '4px' }}
                      />
                      <small className="fw-semibold">{activity.tauxPaiement.toFixed(1)}%</small>
                    </div>
                    {activity.tauxPaiement === 0 && activity.nombreContribuables > 0 && (
                      <small className="text-muted">En attente de paiement</small>
                    )}
                    {activity.tauxPaiement === 100 && activity.nombreContribuables > 0 && (
                      <small className="text-success">Entièrement recouvré</small>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {professionnelTotalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <Pagination size="sm">
              <Pagination.Prev disabled={professionnelCurrentPage === 1} onClick={() => setProfessionnelCurrentPage(p => p - 1)} />
              {[...Array(Math.min(5, professionnelTotalPages))].map((_, i) => {
                let pageNum = i + 1;
                if (professionnelCurrentPage > 3 && professionnelTotalPages > 5) {
                  pageNum = professionnelCurrentPage - 2 + i;
                  if (pageNum > professionnelTotalPages) return null;
                }
                return (
                  <Pagination.Item key={pageNum} active={pageNum === professionnelCurrentPage} onClick={() => setProfessionnelCurrentPage(pageNum)}>
                    {pageNum}
                  </Pagination.Item>
                );
              })}
              <Pagination.Next disabled={professionnelCurrentPage === professionnelTotalPages} onClick={() => setProfessionnelCurrentPage(p => p + 1)} />
            </Pagination>
          </div>
        )}
      </>
    )}
  </div>
</Tab>
                <Tab 
                  eventKey="timeline" 
                  title={
                    <span>
                      <ClockHistory className="me-2" size={16} />
                      Timeline ({filteredActivities.length})
                      {loadingTimeline && <Spinner animation="border" size="sm" className="ms-2" />}
                    </span>
                  }
                >
                  <div className="p-4">
                    <div className="d-flex gap-3 mb-4">
                      <InputGroup style={{ maxWidth: '300px' }}>
                        <InputGroup.Text><Search size={16} /></InputGroup.Text>
                        <Form.Control
                          placeholder="Rechercher..."
                          value={taxFilterText}
                          onChange={(e) => setTaxFilterText(e.target.value)}
                        />
                      </InputGroup>
                      <Form.Select
                        style={{ width: '180px' }}
                        value={activityFilter}
                        onChange={(e) => setActivityFilter(e.target.value)}
                      >
                        <option value="all">Toutes les activités</option>
                        <option value="echeance">Échéances</option>
                        <option value="paiement">Paiements</option>
                        <option value="alerte">Alertes</option>
                      </Form.Select>
                    </div>

                    {loadingTimeline ? (
                      <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3 text-muted">Chargement des activités...</p>
                      </div>
                    ) : filteredActivities.length === 0 ? (
                      <div className="text-center py-5">
                        <Activity size={48} className="text-muted mb-3 opacity-25" />
                        <h5>Aucune activité</h5>
                        <p className="text-muted">Aucune activité pour les contribuables de cette catégorie</p>
                      </div>
                    ) : (
                      <>
                        <div className="timeline">
                          {paginatedActivities.map((activity, index) => {
                            const IconComponent = activity.icon;
                            return (
                              <div className="timeline-item" key={activity.id || index}>
                                <div className={`timeline-marker bg-${activity.color}`} />
                                <div className="timeline-content">
                                  <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                    <div className="d-flex align-items-center">
                                      <div className={`bg-${activity.color} bg-opacity-10 p-2 rounded-circle me-3`}>
                                        <IconComponent className={`text-${activity.color}`} size={18} />
                                      </div>
                                      <div>
                                        <h6 className="mb-1 fw-semibold">{activity.title}</h6>
                                        <p className="text-muted small mb-0">{activity.description}</p>
                                      </div>
                                    </div>
                                    <div className="text-end">
                                      <small className="text-muted d-block">{formatDate(activity.date)}</small>
                                      <small className="text-muted">{formatRelativeTime(activity.date)}</small>
                                    </div>
                                  </div>

                                  {activity.montant > 0 && (
                                    <div className="mt-3 pt-2 border-top">
                                      <div className="d-flex gap-3">
                                        <div>
                                          <small className="text-muted">Montant</small>
                                          <div className="fw-bold text-primary">{formatCurrency(activity.montant)}</div>
                                        </div>
                                        {activity.montantPaye > 0 && (
                                          <div>
                                            <small className="text-muted">Payé</small>
                                            <div className="fw-bold text-success">{formatCurrency(activity.montantPaye)}</div>
                                          </div>
                                        )}
                                        {activity.reste > 0 && (
                                          <div>
                                            <small className="text-muted">Reste</small>
                                            <div className="fw-bold text-danger">{formatCurrency(activity.reste)}</div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="d-flex flex-wrap gap-2 mt-3">
                                    {activity.contribuable && (
                                      <Badge 
                                        bg="light" 
                                        text="dark" 
                                        className="px-2 py-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate(`/agent/ContribuableDetails/${activity.contribuable.contribuable_id}`)}
                                      >
                                        <Person className="me-1" size={10} />
                                        {activity.contribuable.nom_contribuable}
                                      </Badge>
                                    )}
                                    {activity.reference && (
                                      <Badge bg="light" text="dark" className="px-2 py-1">
                                        Ref: {activity.reference}
                                      </Badge>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {activityTotalPages > 1 && (
                          <div className="d-flex justify-content-center mt-4">
                            <Pagination size="sm">
                              <Pagination.Prev disabled={activityPage === 1} onClick={() => setActivityPage(p => p - 1)} />
                              {[...Array(Math.min(5, activityTotalPages))].map((_, i) => {
                                let pageNum = i + 1;
                                if (activityPage > 3 && activityTotalPages > 5) {
                                  pageNum = activityPage - 2 + i;
                                  if (pageNum > activityTotalPages) return null;
                                }
                                return (
                                  <Pagination.Item key={pageNum} active={pageNum === activityPage} onClick={() => setActivityPage(pageNum)}>
                                    {pageNum}
                                  </Pagination.Item>
                                );
                              })}
                              <Pagination.Next disabled={activityPage === activityTotalPages} onClick={() => setActivityPage(p => p + 1)} />
                            </Pagination>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </Tab>
              </Tabs>
            </Card.Header>
          </Card>
        </div>

        {/* Modal d'édition */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title><Pencil className="me-2" size={18} /> Modifier la catégorie</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Nom de la catégorie</Form.Label>
                <Form.Control
                  type="text"
                  value={editedCategory?.name || ''}
                  onChange={(e) => setEditedCategory({ ...editedCategory, name: e.target.value })}
                  placeholder="Ex: Commerce, Artisanat..."
                />
              </Form.Group>
              <Form.Group>
                <Form.Label className="fw-semibold">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={editedCategory?.description || ''}
                  onChange={(e) => setEditedCategory({ ...editedCategory, description: e.target.value })}
                  placeholder="Description de la catégorie (optionnelle)"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              <X className="me-2" size={14} /> Annuler
            </Button>
            <Button variant="primary" onClick={handleSaveEdit} disabled={loadingUpdate}>
              {loadingUpdate ? <Spinner size="sm" className="me-2" /> : <Save className="me-2" size={14} />}
              Enregistrer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de suppression */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title><ExclamationTriangle className="me-2" size={18} /> Confirmer la suppression</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Trash size={48} className="text-danger mb-3" />
              <h5>Supprimer cette catégorie ?</h5>
              <p className="text-muted mb-3">
                Êtes-vous sûr de vouloir supprimer la catégorie <strong>"{category.name}"</strong> ?
              </p>
              <Alert variant="warning" className="text-start">
                <ExclamationTriangle className="me-2" />
                <strong>Attention :</strong> Cette action est irréversible.
                <ul className="mt-2 mb-0">
                  <li>{stats.totalProfessionnelActivities} activité(s) associée(s)</li>
                  <li>{stats.totalContribuables} contribuable(s)</li>
                </ul>
              </Alert>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Annuler
            </Button>
            <Button variant="danger" onClick={handleDelete} disabled={loadingDelete}>
              {loadingDelete ? <Spinner size="sm" className="me-2" /> : <Trash className="me-2" size={14} />}
              Supprimer
            </Button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>

      <style>{`
        .stats-card {
          transition: all 0.3s ease;
          border-radius: 16px;
        }
        .stats-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
        }
        .spin {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .timeline {
          position: relative;
          padding-left: 30px;
        }
        .timeline::before {
          content: '';
          position: absolute;
          left: 15px;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #e9ecef;
        }
        .timeline-item {
          position: relative;
          margin-bottom: 1.5rem;
        }
        .timeline-marker {
          position: absolute;
          left: -30px;
          top: 5px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 0 0 2px #e9ecef;
          z-index: 1;
        }
        .timeline-content {
          background: white;
          padding: 1rem;
          border-radius: 12px;
          border: 1px solid #e9ecef;
          transition: all 0.2s ease;
        }
        .timeline-content:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        }
        .table tbody tr {
          transition: all 0.2s ease;
        }
        .table tbody tr:hover {
          background-color: #f8fbff;
        }
        .nav-tabs .nav-link {
          border: none;
          border-radius: 8px;
          padding: 10px 20px;
          color: #6c757d;
          font-weight: 500;
          transition: all 0.2s;
        }
        .nav-tabs .nav-link:hover {
          background-color: #e9ecef;
          color: #0d6efd;
        }
        .nav-tabs .nav-link.active {
          background-color: #0d6efd;
          color: white;
        }
        .page-link {
          border-radius: 8px;
          margin: 0 2px;
          color: #0d6efd;
        }
        .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
        }
        th {
          cursor: pointer;
          transition: background-color 0.2s;
        }
        th:hover {
          background-color: rgba(13, 110, 253, 0.05);
        }
      `}</style>
    </>
  );
}